import { useStaleBuildRecovery } from '@rammetec/app-kit/errors'
import { rtLogService } from '@rammetec/core'
import { useEffect, useRef } from 'react'
import { useNavigate, useRouteError } from 'react-router-dom'
import { STALE_BUILD_OPTIONS } from '@/shared/errors/staleBuildOptions'
import { AppErrorScreen } from './AppErrorScreen'
import { RouteFallback } from './RouteFallback'

export function RouteErrorBoundary({ fit = 'content' }: { fit?: 'page' | 'content' }) {
  const error = useRouteError()
  const navigate = useNavigate()
  const loggedRef = useRef(false)
  const { isStaleBuild, reloading, reload } = useStaleBuildRecovery(error, STALE_BUILD_OPTIONS)

  useEffect(() => {
    if (loggedRef.current || reloading) {
      return
    }

    loggedRef.current = true

    if (isStaleBuild) {
      rtLogService.warn('Stale build recovery blocked by anti-loop guard', {
        kind: 'stale-build-blocked',
        href: globalThis.location.href,
        message: error instanceof Error ? error.message : String(error),
      })
      return
    }

    rtLogService.error('Route error boundary captured an error', {
      href: globalThis.location.href,
      message: error instanceof Error ? error.message : String(error),
      stack: error instanceof Error ? error.stack : undefined,
    })
  }, [error, isStaleBuild, reloading])

  if (reloading) {
    return <RouteFallback />
  }

  return (
    <AppErrorScreen
      error={error}
      fit={fit}
      onReload={reload}
      onRetry={() => navigate(0)}
    />
  )
}
